const POTENCIA_SPEC = {
  label: 'Potência — trifásico',
  caption: 'Subestação · tanque 3,2 × 1,8 × 1,7 m · 3 fases',
  tank: { width: 3.2, height: 1.8, depth: 1.7 },
  fins: { front: 16, side: 8, depth: 0.22 },
  bushings: {
    phases: 3,
    hv: {
      height: 1.0, sheds: 7, shaftRadius: 0.055, shedRadius: 0.16, step: 0.95,
    },
    lv: {
      height: 0.55, sheds: 5, shaftRadius: 0.05, shedRadius: 0.13, step: 0.75,
    },
  },
  conservator: { radius: 0.40 },
};

/*
 * Malha real do transformador, exportada do CAD e servida de `public/` (ver
 * public/static/models/): 6,2 M de triângulos, sem normais nem UV — o `.mtl`
 * do export não veio, então não há textura de origem para mapear, e quem
 * reconstrói relevo e arestas é o sombreamento por face (ver buildMeshModel em
 * CmaAsset3dView.vue).
 *
 * `alturaAlvo` é em metros e é ela que decide o tamanho na cena: o arquivo já
 * chega em metros, centrado em X/Z e com a base em Y = 0, mas a malha do CAD
 * está em escala reduzida (1,21 m de altura), então a cena a escala
 * uniformemente até a mesma presença em quadro do modelo procedural, que chega
 * a ~8 m com as buchas.
 */
const TFMP_MESH = {
  url: '/static/models/transformador-tfmp.glb',
  /*
   * Altura do ativo na cena, do chão ao ponto mais alto. Fechada em 9,5 (49% da
   * altura do quadro de repouso, contra 41% dos 8,0 anteriores): a largura
   * resultante fica perto dos ~11,5 do modelo procedural, e a meia-diagonal do
   * pior canto sobra confortável frente ao anel verde do piso, que só é cruzado
   * por volta de 15.
   */
  alturaAlvo: 9.5,
  /*
   * Giro em torno de Y. O eixo longo desta malha é Z e o do modelo procedural é
   * X — os dois estão a 90° um do outro. Sem o giro, o CAD apresenta à câmera o
   * lado estreito (lê como menor), cobre 42% do emblema do piso em vez de 32%,
   * e deixa os dois bancos de ventiladores praticamente na mesma âncora, um
   * atrás do outro, o que atrapalharia o card de resfriamento.
   */
  giroY: Math.PI / 2,
};

/*
 * As variantes do carrossel: uma por posição do anel, e é a POSIÇÃO que importa
 * — o carrossel existe para que a troca de ativo tenha um modelo de destino
 * para onde girar, não para mostrar transformadores diferentes.
 *
 * As TRÊS carregam a mesma malha do CAD (`mesh`, ver TFMP_MESH acima): cada
 * uma chama `buildCadModel` (CmaAsset3dView.vue) com seu próprio `group`, o
 * que baixa e monta o GLB uma vez por slot — depois da primeira, o browser
 * serve as demais do cache HTTP. `construirPartes`/`construirAncoras`
 * (transformadorCad.js) rodam por slot, então explosão, foco por card e
 * highlight funcionam igual nos três.
 */
export const TRANSFORMER_MODELS = [
  { id: 'potencia', ...POTENCIA_SPEC, mesh: TFMP_MESH },
  { id: 'potencia-2', ...POTENCIA_SPEC, mesh: TFMP_MESH },
  { id: 'potencia-3', ...POTENCIA_SPEC, mesh: TFMP_MESH },
];

export const DEFAULT_MODEL_ID = TRANSFORMER_MODELS[0].id;

/**
 * A variante que representa o ativo na POSIÇÃO `index` da lista achatada de
 * ativos: os três primeiros ficam com um modelo cada e a ordem se repete daí
 * em diante.
 *
 * É por posição, e não por hash do id, para que ativos vizinhos na árvore
 * caiam sempre em slots vizinhos do anel — é o que dá ao giro um sentido:
 * avançar na lista gira para um lado, voltar gira para o outro.
 */
export function modelIdForAssetIndex(index) {
  if (!Number.isInteger(index) || index < 0) return DEFAULT_MODEL_ID;
  return TRANSFORMER_MODELS[index % TRANSFORMER_MODELS.length].id;
}
